import { CSSObject } from "@emotion/react";

export const pageContentContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: "32px",
};
